import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const getSellerPIPunchs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-pi-punch/`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerPIPunchs - error", error)
        return handleApiError(error)
    }
}

export const postPIPunch = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-pi-punch/create`, data);
        return await response.data;
    } catch (error) {
        console.log("postPIPunch - error", error)
        return handleApiError(error)
    }
}

export const updateSellerPIPunchToHighPriority = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-pi-punch/update-priority`, data);
        return await response.data;
    } catch (error) {
        console.log("updateSellerPIPunchToHighPriority - error", error)
        return handleApiError(error)
    }
}

export const updateSellerPIPunchSkipVerification = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-pi-punch/skip-verification`, data);
        return await response.data;
    } catch (error) {
        console.log("updateSellerPIPunchSkipVerification - error", error)
        return handleApiError(error)
    }
}

export const updateSellerPIPunchVerificationStatus = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-pi-punch/update-verification`, data);
        return await response.data;
    } catch (error) {
        console.log("updateSellerPIPunchVerificationStatus - error", error)
        return handleApiError(error)
    }
}

export const getSellerPIPunchById = async (sellerPIPunchId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-pi-punch/${sellerPIPunchId}`);
        return await response.data;
    } catch (error) {
        console.log("postPIPunch - error", error)
        return handleApiError(error)
    }
}

export const getSellerPIPunchBySellerPOId = async (data) => {
    try {
        const { sellerPOId } = data 
        const response = await axios.get(`${REACT_APP_API_URL}/seller-pi-punch/seller-po/${sellerPOId}`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerPIPunchBySellerPOId - error", error)
        return handleApiError(error)
    }
}

export const getSellerPIPunchByBuyerReqId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-pi-punch/all-pi-punch`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerPIPunchByBuyerReqId - error", error)
        return handleApiError(error)
    }
}

export const updateSellerPIPunch = async (sellerPIPunchId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-pi-punch/update/${sellerPIPunchId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateSellerPIPunchId - error", error)
        return handleApiError(error)
    }
}

export const updateEInvoiceOnSellerPIPunch = async (sellerPIPunchId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-pi-punch/update-einvoice/${sellerPIPunchId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateEInvoiceOnSellerPIPunch - error", error)
        return handleApiError(error)
    }
}

export const deleteSellerPIPunch = async (sellerPIPunchId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-pi-punch/delete-pi-punch/${sellerPIPunchId}`);
        return await response.data;
    } catch (error) {
        console.log("updateSellerPIPunchId - error", error)
        return handleApiError(error)
    }
}


export const getTotalCompanyAmountByCompanyId = async (companyId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-pi-punch/total-amount/${companyId}`);
        return await response.data;
    } catch (error) {
        console.log("getTotalCompanyAmountByCompanyId - error", error)
        return handleApiError(error)
    }
}

export const getSellerPIPunchByDocNo = async (docNo) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-pi-punch/get-seller-pi-punch-by-doc-no/${docNo}`);
        return await response.data;
    } catch (error) {
        console.log("getSellerPIPunchByDocNo - error", error)
        return handleApiError(error)
    }
}